module.exports = __webpack_public_path__ + "static/media/LouiseKelly.7c515c9c.jpg";